/* eslint-disable react-hooks/rules-of-hooks */
import type { ComponentType } from "react";
import { useMemo } from "react";
import type {
    IServices } from "app/pages/industry-analysis/overview/components/IndustryOverviewContext/IndustryOverviewContext";
import {
    IndustryOverviewContext,
} from "app/pages/industry-analysis/overview/components/IndustryOverviewContext/IndustryOverviewContext";
import { i18nFilter } from "app/filters/i18nFilter";
import { apiHelper } from "app/common/services/apiHelper";
import { DefaultFetchService } from "app/services/fetchService";
import { allTrackers } from "app/services/track/track";
import DurationService from "app/services/DurationService";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import categoryService from "app/common/services/categoryService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WithIndustryOverviewContextHOC = (Component: ComponentType) => {
    return function(props) {
        const services = useMemo<IServices>(() => {
            return {
                translate: i18nFilter(),
                navigator: proNavigator,
                apiHelper: apiHelper,
                fetchService: DefaultFetchService.getInstance(),
                tracker: allTrackers,
                durationService: DurationService,
                categoryService: categoryService,
                customCategoryService: UserCustomCategoryService,
            };
        }, []);

        return (
            <IndustryOverviewContext.Provider value={{ services }}>
                <Component {...props} />
            </IndustryOverviewContext.Provider>
        );
    };
};
